module.exports = __webpack_public_path__ + "static/media/resolved-time.4db1f150.svg";